/**
 * =============================================================================
 * product-tile-manager.js
 * =============================================================================
 * Generate ProductForm objects for all product forms on page.
 * 
 * TODO: Handle tiles loaded in dynamically (e.g. collection infiniload, product
 * recommendations, etc)
 * =============================================================================
 */

 import ProductTile from "./product-tile";

 var ProductTileManager = {
   tiles: {},
 
   init: function() {
     // Get all of the product containers. This will usually just be 1 (i.e the
     // product page), but could be multiple (i.e. multiple sections on a JSON
     // template using the 'featured-product' section)
     let tiles = document.querySelectorAll(".tile-product");
     tiles.forEach(element => {
       let tile = new ProductTile(element);
       this.tiles[element.id] = tile;
     });
 
     // console.log(`[PTM] Found ${Object.keys(this.tiles).length} product tiles(s)`, this.tiles);

     // Need to regen when page updates, tiles load, etc etc
   }
 }
 
 export default ProductTileManager;